<template>
  <!-- eslint-disable vue/no-unused-vars -->
  <div class="view-container text-center">
    <div class="text-right cursor-pointer">
      <b-button variant="link" @click="back">
        <font-awesome-icon icon="times" />
      </b-button>
    </div>

    <loading-spinner v-if="loading" />

    <template v-else-if="item.id">
      <b-alert 
        v-if="!this.$store.state.auth.user.isCafSession && this.item.caf"
        show 
        variant="warning" 
        class="mb-4 text-center font-weight-bold"
      >
        <b> Autodichiarazione gestita dal CAF {{ item.caf.nominativo }}. </b>
        <span>
          {{ item.stato === 'V' 
            ? 'Per creare una nuova dichiarazione a partire da questa,'
            : 'Per completare o annullare la dichiarazione,'
          }}
          rivolgersi presso un CAF {{ item.caf.nominativo }}.
        </span>
        </b-alert>

      <!-- <div class="row justify-content-between px-3 mb-4">
        <img src="../assets/images/logo-comune.png" style="height:80px">
        <div class="p-5">
          <span v-if="item.numeroProtocollo" class="protocollo ml-3">
            Prot. n. {{ item.numeroProtocollo }}
          </span>
        </div>
      </div> -->

      <div class="row px-3 mb-4">
        <div class="col-3">
          <img src="../assets/images/logo-comune.png" style="height:80px">
        </div>
        <div class="col-9 d-flex flex-column align-items-end">
          <div v-if="item.numeroProtocollo" class="protocollo mb-2">
            Prot. n. {{ item.numeroProtocollo }}
          </div>
          <div v-if="item.numeroProtocolloSubentro" class="protocollo mb-2">
            Prot. subentro n. {{ item.numeroProtocolloSubentro }}
          </div>
          <div v-if="item.numeroProtocolloAmpliamento" class="protocollo">
            Prot. ampliamento n. {{ item.numeroProtocolloAmpliamento }}
          </div>
        </div>
      </div>
    
      <h2 class="text-center mt-4 text-uppercase">
        Accertamento dati anagrafici, redditi e patrimonio
      </h2>
      <div class="text-center">
        Dichiarazione sostitutiva resa ai sensi degli artt. 46 e 47 del D.P.R. 445/2000
      </div>
      <h4 class="text-center text-primary mt-3 mb-5 font-weight-bold text-uppercase">
        <span v-if="isOpen">
          dichiarazione da confermare
        </span>
      </h4>

      <p class="text-justify px-4">
        <span>{{ isDichiarante ? 'Il/La dichiarante' : 'Il/La sottoscritto/a' }}</span>
        <span class="form-field" v-if="isDichiarante"> {{ item.nominativoDichiarante }} </span>
        <span class="form-field" v-if="isDichiarante"> {{`(${item.cfDichiarante})`}} </span>
        <span>{{ isDichiarante ? ' in nome e per conto/in luogo di' : '' }}</span>
        <span class="form-field">{{ item.nome }}</span>
        <span class="form-field">{{ item.cognome }}</span>
        <span>{{ isDichiarante ? `intestatario dell'immobile` : `titolare di regolare assegnazione dell'immobile` }} ubicato in</span>
        <span class="form-field">{{ item.descrizioneComune }} ({{ item.provincia }})</span>
        <span>, via</span>
        <span class="form-field">{{ item.indirizzo }}</span>
        <span>, codice BU</span>
        <span class="form-field text-nowrap">{{ item.codiceUib }}</span>
        <!-- <span>, codice RU</span>
        <span class="form-field text-nowrap">{{ item.codiceUtente }}</span> -->
        <span>, con nucleo familiare composto da n.</span>
        <span class="form-field">{{ item.numeroComponenti }}</span>
        <span>
          componenti, consapevole delle conseguenze civili e penali a cui può andare incontro in caso di dichiarazione mendace o di esibizione di atto falso
          o contenente dati non più rispondenti a verità, a norma dell'art. 76 D.P.R. 28 dicembre 2000, n.445
        </span>
      </p>

      <p class="text-center font-weight-bold my-3 text-uppercase">
        dichiara
      </p>

      <div class="row my-3">
        <div class="col-auto" style="max-width:1.5rem;">
          <b-check class="form-check" :disabled="!isOpen || this.item.stato === 'P'" v-model="item.checks[0]"/>
        </div>
        <div class="col text-justify">
          {{ item.anno === 2023 
            ? `di seguito l'attuale composizione del seguente nucleo familiare e i redditi percepiti nell'anno 2023:`
            : `che il proprio nucleo familiare, determinato ai sensi dell'art. 11, comma 5, ovvero ampliato ai sensi dell'art. 12, comma 4, della L.R.L 12/1999, nell'anno di imposta`
          }}
          <span v-if="!(item.anno === 2023)">
            <span class="form-field">
              {{ item.anno }}
            </span> , era così composto:
          </span>
        </div>
      </div>

      <div class="ml-4 mb-3">
        <redditi-table :item="item" :originiSoggetto="originiSoggetto"/>
      </div>
      <!-- Nuova checkbox per ampliamento nucleo familiare -->
      <div v-if="nucleoExpandedFromOriginal" 
          class="row mb-3 mt-3 justify-content-center">
        <div class="col-10 p-3 bg-warning rounded text-center">
          <div class="d-flex align-items-center">
            <div class="mx-2">
              <b-check class="form-check" 
                      :disabled="!isOpen || this.item.stato === 'P'" 
                      v-model="item.hasAmpliamentoRequested"/>
            </div>
            <div class="flex-grow-1 text-left font-weight-bold">
              Presenta contestuale istanza di Ampliamento del nucleo familiare
            </div>
          </div>
        </div>
      </div>

      <div class="row my-3">
        <div class="col-auto" style="max-width:1.5rem;">
          <b-check class="form-check" :disabled="!isOpen || this.item.stato === 'P'" v-model="item.checks[1]"/>
        </div>
        <div class="col text-justify">
          che né il/la sottoscritto/a né i componenti il nucleo familiare, sono titolari del diritto di proprietà, usufrutto, uso o abitazione su di un alloggio adeguato alle esigenze del proprio nucleo familiare nel territorio di Roma Capitale o nel Comune di residenza, qualora diverso da quello in cui si svolge l’attività lavorativa, e comunque nell’ambito del territorio nazionale, su beni patrimoniali di valore complessivo superiore a quello fissato dall’art. 21 del Regolamento Regionale n. 2 del 20 settembre 2000;
        </div>
      </div>

      <div class="row my-3">
        <div class="col-auto" style="max-width:1.5rem;">
          <b-check class="form-check" :disabled="!isOpen || this.item.stato === 'P'" v-model="item.checks[2]"/>
        </div>
        <div class="col text-justify">
          che i componenti il nucleo familiare sono proprietari titolari di diritti di godimento sui seguenti immobili:
        </div>
      </div>

      <div class="ml-4 mb-3">
        <immobili-table :item="item" />
      </div>

      <div class="row my-3">
        <div class="col-auto" style="max-width:1.5rem;">
          <b-check class="form-check" :disabled="!isOpen || this.item.stato === 'P'" v-model="item.checks[3]"/>
        </div>
        <div class="col text-justify">
          che né il/la sottoscritto/a né altri componenti il nucleo familiare, hanno ottenuto l’assegnazione in proprietà originaria o derivata, immediata e futura di alloggio realizzato con contributi pubblici o finanziamento agevolato in qualunque forma concesso dallo Stato o da Enti Pubblici (salvi i casi di alloggio inutilizzabile o perito in assenza di risarcimento del danno o di esproprio per pubblica utilità);
        </div>
      </div>

      <div class="row my-3">
        <div class="col-auto" style="max-width:1.5rem;">
          <b-check class="form-check" :disabled="!isOpen || this.item.stato === 'P'" v-model="item.checks[4]"/>
        </div>
        <div class="col text-justify">
          che né il/la sottoscritto/a né altri componenti il nucleo familiare, hanno ottenuto in assegnazione, occupato senza titolo o ceduto in tutto o in parte, al di fuori dei casi previsti dalla legge, alloggi di Edilizia Residenziale Pubblica, fatta eccezione per la situazione attuale e salvo quanto stabilito dall’art. 15, comma 4, L.R.L. n. 12/1999.
        </div>
      </div>

      <div class="row my-3">
        <div class="col-auto" style="max-width:1.5rem;">
          <b-check class="form-check" :disabled="!isOpen || this.item.stato === 'P'" v-model="item.checks[5]"/>
        </div>
        <div class="col text-justify">
          Il/La dichiarante è pienamente consapevole che in caso di mancata o tardiva restituzione del presente modulo debitamente compilato od in presenza di dichiarazioni incomplete o inattendibili, Roma Capitale procederà d’ufficio alla determinazione del canone di locazione nella misura e con le modalità stabilite dalla vigente normativa E.R.P. (art. 50, comma 2quater, L.R.L. n. 27/2006), che prevede l’applicazione dell’importo massimo calcolabile (fascia massima); è altresì consapevole che in caso di non veridicità del contenuto della dichiarazione, decade immediatamente dai benefici eventualmente prodotti dal provvedimento emanato sulla base della dichiarazione non veritiera, ai sensi dell’art. 75 del D.P.R. 28 dicembre 2000, n. 445.
        </div>
      </div>
      <div v-if="item.cfDichiarante && item.cfDichiarante !== item.codiceFiscale && hasSubentroRequested">
        <h3 class="text-center mt-4 text-uppercase">
          DICHIARA INOLTRE
        </h3>
        <div class="text-center">
          (CONDIZIONI PER IL SUBENTRO)  
        </div>

        <br>
        <p class="text-justify px-4">Di essere in possesso, unitamente agli altri componenti del nucleo familiare riportato, dei requisiti previsti dalla legge e </p>
        
        <div class="row my-3">
          <div class="col-auto" style="max-width:1.5rem;">
            <b-check class="form-check" 
                     :disabled="!isOpen || this.item.stato === 'P'" 
                     :checked="item.subentroSelezionato && Number(item.subentroSelezionato.indice) === 0"
                     @change="handleSubentroSelection(0)"/>
          </div>
          <div class="col text-justify">
            che l'immobile sopraindicato è stato assegnato al/alla sottoscritto/a dal Tribunale Civile a seguito di sentenza di divorzio / separazione giudiziale / scioglimento dell'unione civile / verbale di separazione consensuale con relativo provvedimento di omologazione del Tribunale (allegare copia autentica della sentenza/verbale di omologazione) o nullità dell'unione civile;
          </div>
        </div>

        <div class="row my-3">
          <div class="col-auto" style="max-width:1.5rem;">
            <b-check class="form-check" 
                     :disabled="!isOpen || this.item.stato === 'P'" 
                     :checked="item.subentroSelezionato && Number(item.subentroSelezionato.indice) === 1"
                     @change="handleSubentroSelection(1)"/>
          </div>
          <div class="col text-justify">
            di essere l'unico avente diritto al subentro, ai sensi dell'art. 12, comma 1, in combinato disposto con l'art. 11, comma 5, della L.R. n. 12/1999;
          </div>
        </div>

        <div class="row my-3">
          <div class="col-auto" style="max-width:1.5rem;">
            <b-check class="form-check" 
                     :disabled="!isOpen || this.item.stato === 'P'" 
                     :checked="item.subentroSelezionato && Number(item.subentroSelezionato.indice) === 2"
                     @change="handleSubentroSelection(2)"/>
          </div>
          <div class="col text-justify">
            di essere il primo avente diritto al subentro in base all'ordine stabilito dall'art. 12, comma 1, in combinato disposto con l'art. 11, comma 5, della L.R. n. 12/1999;
          </div>
        </div>

        <div class="row my-3">
          <div class="col-auto" style="max-width:1.5rem;">
            <b-check class="form-check" 
                     :disabled="!isOpen || this.item.stato === 'P'" 
                     :checked="item.subentroSelezionato && Number(item.subentroSelezionato.indice) === 3"
                     @change="handleSubentroSelection(3)"/>
          </div>
          <div class="col text-justify">
            di essere il primo avente diritto al subentro, a seguito di rinuncia al subentro sottoscritta e firmata dal primo avente diritto in base all'ordine stabilito dall'art. 12, comma 1, in combinato disposto con l'art. 11, comma 5, della L.R. n. 12/1999
            <br><i>(allegare dichiarazione di rinuncia al subentro sottoscritta e firmata dal primo avente diritto al subentro in base all'ordine stabilito dalla L.R. n. 12/1999, completa di documento d'identità)</i>
          </div>
        </div>

        <h3 class="text-center mt-4 text-uppercase">
            CHIEDE
        </h3>
        <p class="text-justify px-4">Di subentrare nell'assegnazione dell'alloggio, con contratto di locazione a proprio nome.</p>
        <p class="text-justify px-4">Consapevole delle conseguenze amministrative e penali della falsità in dichiarazioni rese, in particolare della revoca dei benefici conseguenti al provvedimento emanato sulla base della dichiarazione non veritiera allo scopo.</p>
        
      </div>

      <p class="small font-italic text-justify mx-4 mb-2">
        <span>I dati acquisiti saranno utilizzati in conformità al nuovo Regolamento Generale sulla Protezione dei Dati Personali (GDPR). Per maggiori dettagli, si prega di consultare la pagina internet: </span>
        <a
          href="https://www.aequaroma.it/societa/privacy-policy.html"
          target="_blank"
        >
          https://www.aequaroma.it/societa/privacy-policy.html
        </a>.
      </p>

      <p v-if="item.dataConferma" class="text-left mt-5">
        Roma,<span class="form-field">
          {{ moment(item.dataConferma).format('DD/MM/YYYY') }}
        </span>
      </p>

      <!-- <pre>
      {{item.redditi[0].allegatoHandicap.idAllegato}}
      {{item.redditi[0].allegatoHandicap.fileName}}
      {{item.redditi[0].allegatoHandicap.file ? item.redditi[0].allegatoHandicap.file.name : 'NO FILE'}}
      </pre> -->

      <div class="row mt-4 mx-2">

        <!-- TODO: Metti bottone protocollo dichiarazione per utentecaf in stato Precompilata -->
        <!-- <b-button v-if="isOpen && !(this.$store.state.auth.user.isCafSession && item.stato === 'P')" variant="success" class="m-2" 
          @click="doSaveConfirm">
          <font-awesome-icon icon="check" class="text-white mr-2"/> 
          {{this.$store.state.auth.user.isCafSession ? "Protocolla dichiarazione" : "Salva e conferma"}}
        </b-button> -->
        <b-button v-if="isOpen && !(item.stato === 'P')" variant="success" class="m-2" 
          @click="doSaveConfirm">
          <font-awesome-icon icon="check" class="text-white mr-2"/> 
          {{this.$store.state.auth.user.isCafSession ? "Protocolla dichiarazione" : "Salva e conferma"}}
        </b-button>
        

        <template v-if="isDocumentInAttesaFirma">
          <b-button
            variant="success"
            class="m-2"
            @click="presentaDichiarazioneCaf"
            :disabled="!documentoFirmatoCaricato"
          >
            <font-awesome-icon icon="check" class="text-white mr-2"/>
            Presenta dichiarazione
          </b-button>
        </template>

        <!-- isOpen "{{isOpen}}"
        Clonabile "{{item.clonable !== 'NO' && (item.stato === 'P' || item.stato === 'V')}}"
        item.clonable "{{item.clonable}}" -->

        <b-button v-if="(!(!this.$store.state.auth.user.isCafSession && this.item.caf)) && 
                       item.clonable !== 'NO' && 
                       (item.stato === 'P' || item.stato === 'V' || item.stato === 'B') && 
                       anniConsentiti.includes(item.anno.toString())" 
          variant="primary" 
          class="m-2" 
          @click="doSaveDraft"
          :disabled="isSaving">
          <font-awesome-icon icon="save" class="text-white mr-2" />
          {{isSaving ? 'Salvataggio in corso...' : 'Salva in bozza'}}
        </b-button>

        <template v-if="!isOpen && (item.stato === 'V' || item.stato === 'C')">
          <b-dropdown variant="success" class="m-2"
            v-if="item.downloadableDocuments && item.downloadableDocuments.length > 1"
            title="Seleziona documento da scaricare"
          >
            <template slot="button-content" >
              <font-awesome-icon icon="download" class="text-white mr-2"/>Scarica documento
            </template>
              <b-dropdown-item
                v-for="(document,idx) in item.downloadableDocuments"
                :key="idx"
                >
                <a
                  target="_blank"
                  :href="urlDichiarazione({id: document.id, tipo: document.tipo, idDich: item.id, redditi: item})"
                  @click.stop
                  v-b-tooltip.hover
                  :title="document.tipo"
                  >
                    {{document.filename ? document.filename : item.filename}}
                </a>
                </b-dropdown-item>
          </b-dropdown>

          <a v-else target="_blank" :href="urlDichiarazione({id: item.id, tipo: 'dichiarazione'})">
            <button class="btn btn-success m-2">
              <font-awesome-icon icon="download" class="text-white mr-2"/>{{isDocumentInAttesaFirma ? 'Scarica documento per firma' : 'Scarica documento'}}
            </button>
          </a>

        </template>

        <template v-if="isDocumentInAttesaFirma">
          <input 
            type="file" 
            ref="fileInput" 
            accept=".pdf"
            @change="handleFileUpload" 
            style="display:none"
          />
          
          <b-button 
            variant="primary" 
            class="m-2" 
            @click="$refs.fileInput.click()"
          >
            <font-awesome-icon icon="upload" class="text-white mr-2"/>
            Carica documento firmato
          </b-button>

          <!-- Campo di visualizzazione nome file -->
          <div class="d-flex align-items-center m-2">
            <b-form-input
              v-model="nomeFileFirmato"
              readonly
              placeholder="Nessun file caricato"
              :class="{'bg-light': true, 'text-muted': !nomeFileFirmato}"
            />
          </div>
        </template>

        <b-button variant="outline-secondary" class="m-2" @click="back">
          <font-awesome-icon icon="times" class="mr-2"/>Chiudi
        </b-button>
  </div>
    </template>

    <b-modal ref="confirmModal"
      title="Conferma operazione"
      :centered="true"
      no-close-on-backdrop
      ok-title="Conferma" ok-variant="success"
      cancel-title="Annulla" cancel-variant="outline-secondary">
      ... testo conferma salvataggio...
    </b-modal>

  </div>
</template>

<script>
import moment from 'moment'
import numeral from 'numeral'
import LoadingSpinner from '@/components/LoadingSpinner'
import RedditiTable from '@/components/RedditiTable'
import ImmobiliTable from '@/components/ImmobiliTable'
import axios from 'axios'

export default {
  components: {
    LoadingSpinner,
    RedditiTable,
    ImmobiliTable
  },

  data () {
    return {
      loading: true,
      isSaving: false,
      item: {
        downloadableDocuments: []
      },
      message: '',
      documentoFirmatoCaricato: false,
      nomeFileFirmato: '',
      documentoFirmato: null,
      cafInfo: null,
      nucleoExpandedFromOriginal: false
    }
  },

  watch: {
    'item.redditi' (newVal) {
      this.item.numeroComponenti = newVal ? newVal.length : 0

      if (this.item.numeroComponentiOriginali < this.item.numeroComponenti) {
        // controlla se nei componenti è presente un componente con tipoComponente = 'ZZ', allora restituisci false
        if (this.item.redditi.some(r => r.tipoComponente === 'ZZ')) {
          this.nucleoExpandedFromOriginal = false
          this.item.hasAmpliamentoRequested = 'false'
        } else {
          this.nucleoExpandedFromOriginal = true
        }
      } else {
        // Quando il numero di componenti torna ad essere uguale o inferiore all'originale
        this.nucleoExpandedFromOriginal = false
        this.item.hasAmpliamentoRequested = 'false'
      }
    }
  },

  computed: {
    // Verifica se il dichiarante è presente nel nucleo familiare
    isDichiarante() {
      return this.item.cfDichiarante && this.item.cfDichiarante !== this.item.codiceFiscale
    },

    // Verifica se il documento è un documento CAF nello stato C (In attesa di firma)
    isDocumentInAttesaFirma() {
      // Serve per gestire la visualizzazione dei bottoni per documenti CAF
      return this.$store.state.auth.user.isCafSession && this.item.stato === 'C'
    },
    moment () {
      return moment
    },
    numeral () {
      return numeral
    },
    anniConsentiti() {
      return this.$store.getters['options/getAnniConsentiti']
    },

    // Verifica se il documento è abilitato per la modifica
    isOpen () {
      const annoNonConsentito = !this.anniConsentiti.includes(this.item.anno.toString())
      return (this.item.stato === 'B' || this.item.stato === 'P') && 
             (!(!this.$store.state.auth.user.isCafSession && this.item.caf)) &&
             !annoNonConsentito
    },
    // urlDichiarazione () {
    //   return `/api/dichiarazioni/${this.item.id}/download`
    // },
    originiSoggetto () {
      // console.log('originiSoggetto', this.$store.state.options)
      return this.$store.state.options.tipoOrigineSoggetto
    },
    // // Verifica se è presente un intestatario subentrante o abusivo
    // hasNewIntestatario() {
    //   return this.item.redditi && 
    //          this.item.redditi.some(reddito => reddito.tipoComponente === 'ZZ' || reddito.tipoComponente === 'IS')
    // },
    // Verifica se è presente una richiesta di subentro
    hasSubentroRequested() {
      return this.item.redditi && 
             this.item.redditi.some(reddito => 
               reddito.tipoComponente === 'IS' && 
               reddito.richiestaPraticaSubentro === 'SI'
             );
    }
  },

  // Carica i dati della dichiarazione
  async created () {
    await this.load()
  },

  methods: {
    async handleFileUpload(event) {
      try {
        const file = event.target.files[0]
        if (!file) return
        
        // Verifica che sia un PDF
        if (file.type !== 'application/pdf') {
          this.$ui.notify({
            type: 'warning',
            title: 'Attenzione',
            message: 'Il file deve essere in formato PDF'
          })
          return
        }

        this.documentoFirmato = file 
        this.nomeFileFirmato = file.name
        this.documentoFirmatoCaricato = true
      } catch (err) {
        this.nomeFileFirmato = ''
        this.documentoFirmato = null
        this.$ui.showError(err)
      } 
    },
    back () {
      this.$router.push({ name: 'dichiarazioni' })
    },

    // Carica i dati della dichiarazione
    async load () {
      try {
        this.loading = true
        await this.$store.dispatch('options/loadTipoOrigineSoggettoOptions')
        
        let id = this.$route.params.id
        let clonable = this.$route.params.clonable
        await this.$store.dispatch('dichiarazioni/loadItemById', id)
        let item = this.$store.state.dichiarazioni.item
        
        // Aggiungiamo le info del dichiarante all'item
        const delegaInfo = await axios.get(`/api/dichiarazioni/${id}/delega-info`)
        if (delegaInfo.data) {
          item.cfDichiarante = delegaInfo.data.cfDichiarante
          item.nominativoDichiarante = delegaInfo.data.nominativoDichiarante

          // Aggiungiamo il nominativoDichiarante che è come nominativoDichiarante ma con '/' al posto degli spazi
          if (item.nominativoDichiarante) {

            item.nominativoDichiaranteGED = item.nominativoDichiarante
            // Rimpiazzo '/' con ' '
            item.nominativoDichiarante = item.nominativoDichiarante.replace(/\//g, ' ')
          }
        }

        // Inizializza i check per la dichiarazione
        item.checks = Array(6).fill(item.stato === 'V' || item.stato === 'C')
        
        // Inizializza subentroSelezionato se non esiste o se siamo nella bozza
        if (!item.subentroSelezionato || item.stato === 'B') {
          item.subentroSelezionato = null;
        }

        item.hasSubentroRequested = this.hasSubentroRequested
        item.clonable = clonable
        this.item = item
      } catch (err) {
        this.$ui.showError(err)
        this.$router.push({ name: 'home' })
      }
      this.loading = false
    },

    // Controlla i dati della dichiarazione prima di salvarla e richiama doSave [B -> V (NORMALE), B -> C (CAF)]
    async doSaveConfirm () {
      let textMessage = ''

      // Verifica se tutti i check sono presenti
      let allChecked = !this.item.checks.some(c => !c)
      
      // Verifica checksSubentro solo se c'è una richiesta esplicita di subentro
      let selectedSubentro = !this.hasSubentroRequested || 
        (this.hasSubentroRequested && this.item.subentroSelezionato !== null);

      let checkTitolare = this.titolareRequired(this.$store.state.auth.user.codiceFiscale)
      let checkComponenti = this.componentiCheck(this.$store.state.auth.user.codiceFiscale)
      // let checkComponenti = this.componentiNotEmpty()
      let verImmobili = await this.checkImmobili(this.item.immobili)

      if (!(allChecked && selectedSubentro && checkTitolare && checkComponenti.value && verImmobili.value)) {
        if (this.hasSubentroRequested && !selectedSubentro) 
          textMessage = 'Selezionare esattamente una delle opzioni per il subentro.'
        if (!allChecked) textMessage = 'Tutte le clausole dichiaratorie devono essere accettate prima del salvataggio del documento.'
        if (!checkTitolare) textMessage = 'Titolare non presente nei componenti il nucleo familiare.'
        if (!checkComponenti.value) textMessage = checkComponenti.descrizione // 'Deve essere presente almeno 1 componente il nucleo familiare.'
        if (!verImmobili.value) textMessage = 'Verificare dati catastali immobili. (' + verImmobili.descrizione + ')'

        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: textMessage
        })
      } else {
        this.$ui.notify({
          type: 'confirm',
          title: 'Richiesta di conferma',
          message: this.$store.state.auth.user.isCafSession && this.item.stato === 'B'  
            ? 'Una volta salvato, il documento non potrà più essere modificato. Confermi la richiesta di protocollazione?' 
            : 'Una volta salvato, il documento non potrà più essere modificato. Confermi il salvataggio del documento?',
          okHandler: this.doSave
        })
      }
    },

    // Salva la dichiarazione per CAF (In attesa di firma -> Confermata [C -> V])
    async presentaDichiarazioneCaf() {
      // Verifica se è presente un documento firmato
      if (!this.documentoFirmatoCaricato || !this.documentoFirmato) {
        this.$ui.notify({
          type: 'warning',
          title: 'Attenzione',
          message: 'È necessario caricare il documento firmato prima di procedere con la conferma'
        })
        return
      }

      // Richiesta di conferma
      this.$ui.notify({
        type: 'confirm',
        title: 'Richiesta di conferma',
        message: 'Confermi la presentazione definitiva del documento?',
        okHandler: async () => {
          try {
            // Inizio salvataggio
            this.loading = true


            const formData = new FormData()
            formData.set('dichiarazione', JSON.stringify(this.item))
            formData.set('nuovoStato', 'V')
            formData.set('documentoFirmato', this.documentoFirmato) 

            // Salvataggio
            await this.$store.dispatch('dichiarazioni/save', {
              id: this.item.id,
              formData
            })

            this.$ui.notify({
              type: 'success',
              title: 'Operazione completata',
              message: `Dichiarazione definitiva presentata con successo. Il numero di protocollo è: ${this.item.numeroProtocollo}`
            })

            this.$router.push({ name: 'dichiarazioni' })
          } catch (err) {
            this.$ui.showError(err)
          } finally {
            this.loading = false
          }
        }
      })
    },
  
    urlDichiarazione (toDownload) {
      let retUrn = ''
      // console.log('toDownload', toDownload.redditi)
      if (toDownload.tipo === 'dichiarazione') {
        retUrn = `/api/dichiarazioni/${toDownload.id}/download`
      } else {
        retUrn = `/api/dichiarazioni/${toDownload.id}/attachment/${toDownload.idDich}`
      }
      return retUrn
    },

    // Salva la dichiarazione [B -> V (NORMALE), B -> C (CAF)]
    async doSave () {
      try {
        let allChecked = !this.item.checks.some(c => !c)
        
        this.item.hasSubentroRequested = this.hasSubentroRequested

        // Verifica checksSubentro solo se c'è una richiesta esplicita di subentro
        let selectedSubentro = !this.hasSubentroRequested || 
          (this.hasSubentroRequested && this.item.subentroSelezionato !== null);

        if (allChecked && selectedSubentro) {
          // Ulteriore verifica su eventuali immobili inseriti.
          this.loading = true

          const formData = new FormData()

          this.item.redditi.filter(r => r.allegatoHandicap ? r.allegatoHandicap.fileName : false).forEach(r => {
            // console.log('f', f, f.idAllegato, this.fileAllegati)
            formData.set(r.codiceFiscale, r.allegatoHandicap.file)
            // r.allegatoHandicap.file = null
          })

          formData.set('dichiarazione', JSON.stringify(this.item))
          formData.set('nuovoStato', 'V')

          // await this.$store.dispatch('dichiarazioni/save', this.item)
          await this.$store.dispatch('dichiarazioni/save', { id: this.item.id, formData })

          let item = this.$store.state.dichiarazioni.item
          item.checks = Array(6).fill(true)
          this.item = item
          this.$ui.notify({
            type: 'success',
            title: 'Esito operazione',
            message: `Operazione eseguita con successo. Il numero di protocollo del documento è: ${this.item.numeroProtocollo}`
          })
          if (!this.$store.state.auth.user.isCafSession) {
            this.back()
          }
        }
      } catch (err) {
        // this.item.stato = 'A'
        this.item.stato = 'B'
        this.$ui.showError(err)
        this.back()
      }
      this.loading = false
    },

    // Salva come bozza (stato P) 
    async doSaveDraft () {
      if (this.isSaving) return
      
      this.isSaving = true
      try {
        this.loading = true

        const formData = new FormData()

        // Recupero allegati
        this.item.redditi.filter(r => r.allegatoHandicap ? r.allegatoHandicap.fileName : false).forEach(r => {
          formData.set(r.codiceFiscale, r.allegatoHandicap.file)
        })

        // Aggiunta dati dichiarazione presi da item
        formData.set('dichiarazione', JSON.stringify(this.item))
        // Verifica se è possibile clonare la dichiarazione (se true, la dichiarazione presa da item è una copia)
        let cloneDich = this.item.clonable !== 'NO' && (this.item.stato === 'P' || this.item.stato === 'V') ? 'Y' : 'N'
        formData.set('cloneDich', cloneDich)

        // Salvataggio
        await this.$store.dispatch('dichiarazioni/save', { id: this.item.id, formData })

        // Dovrei ricaricare/verificare l'eventuale allegato al componente nucle familiare.
        let item = this.$store.state.dichiarazioni.item
        item.checks = Array(6).fill(false)
        item.subentroSelezionato = null
        this.item = item
        this.$ui.notify({
          type: 'success',
          title: 'Esito operazione',
          message: 'Operazione eseguita con successo.'
        })
        if (cloneDich === 'Y') this.$router.push({ name: 'dichiarazioni' })
      } catch (err) {
        this.$ui.showError(err)
      } finally {
        this.loading = false
        this.isSaving = false
      }
    },

    // Verifica se è presente un titolare / intestatario
    titolareRequired (codiceFiscale) {
      let idRet = true

      const intestatario = this.item.redditi.filter(r => r.tipoComponente === 'IN')
      const iscritti = this.item.redditi.filter(r => r.tipoComponente === 'IS')
      const abusivi = this.item.redditi.filter(r => r.tipoComponente === 'ZZ')

      if (!iscritti.length && !abusivi.length && !intestatario.length) {
        return false
      }

      // Verifica se presente titolare / intestatario
      idRet = Array.isArray(this.item.redditi) ? !!this.item.redditi.find(reddito => reddito.codiceFiscale === codiceFiscale) : false
      return idRet
    },

    componentiCheck (codiceFiscale) {
      let idRet = true
      let idMess = null

      if (Array.isArray(this.item.redditi)) {
        // Verifica presenza 1 solo coniuge
        let redditiFiltered = this.item.redditi.filter(reddito => {
          // console.log('reddito', reddito, reddito.tipoComponente)
          if (reddito.tipoComponente === 'CO') return true
        }) // CO => Coniuge
        idRet = idRet && redditiFiltered.length <= 1
        if (!idRet) idMess = 'Verificare componenti nucleo familiare. Non è possibile specificare più di un coniuge.'
        // console.log('redditiFiltered', idRet, redditiFiltered, this.item.redditi)

        // if (!idMess) {
        //   // Verifica presenza 1 solo Intestatario
        //   redditiFiltered = null
        //   redditiFiltered = this.item.redditi.filter(reddito => {
        //     // console.log('reddito', reddito, reddito.tipoComponente)
        //     if (reddito.tipoComponente === 'IN') return true
        //   }) // IN => Intestatario
        //   idRet = idRet && redditiFiltered.length === 1
        //   if (!idRet) {
        //     if (redditiFiltered.length < 1) idMess = 'Verificare componenti nucleo familiare. Deve essere indicato un "intestatario".'
        //     if (redditiFiltered.length > 1) idMess = 'Verificare componenti nucleo familiare. Deve essere indicato un solo "intestatario".'
        //     // idMess = 'Verificare componenti nucleo familiare. Deve essere indicato un "intestatario".'
        //   }
        // }

        if (!idMess) {

          const intestatari = this.item.redditi.filter(r => r.tipoComponente === 'IN')
          const iscritti = this.item.redditi.filter(r => r.tipoComponente === 'IS')
          const abusivi = this.item.redditi.filter(r => r.tipoComponente === 'ZZ')

          // Conta quanti tipi di intestatari sono presenti
          const tipiIntestariPresenti = [
            intestatari.length > 0,
            iscritti.length > 0,
            abusivi.length > 0
          ].filter(Boolean).length;

          // Verifica che ci sia solo un tipo di intestatario
          if (tipiIntestariPresenti > 1) {
            return {
              value: false,
              descrizione: 'Verificare componenti nucleo familiare. Non è possibile avere più di un tipo di intestatario (intestatario, intestatario subentrante o intestatario abusivo).'
            };
          }

          if (intestatari.length > 0) {
            // Caso 1: Presente IN
            if (intestatari.length > 1) {
              return { 
                value: false, 
                descrizione: 'Verificare componenti nucleo familiare. Deve essere indicato un solo "intestatario".' 
              };
            }
            
            // Verifica CF intestatario
            if (intestatari[0].codiceFiscale !== codiceFiscale) {
              return { 
                value: false, 
                descrizione: 'Verificare componenti nucleo familiare. Il codice fiscale dell\'intestatario non corrisponde.' 
              };
            }
          } else if (iscritti.length > 0) {
            // Caso 2: Presente IS
            if (iscritti.length > 1) {
              return { 
                value: false, 
                descrizione: 'Verificare componenti nucleo familiare. Deve essere presente un solo "intestatario subentrante".' 
              };
            }
          } else if (abusivi.length > 0) {
            // Caso 3: Presente ZZ
            if (abusivi.length > 1) {
              return { 
                value: false, 
                descrizione: 'Verificare componenti nucleo familiare. Deve essere presente un solo "intestatario abusivo".' 
              };
            }
          } else {
            // Nessun tipo di intestatario presente
            return { 
              value: false, 
              descrizione: 'Verificare componenti nucleo familiare. Deve essere presente un "intestatario", un "intestatario subentrante" o un "intestatario abusivo".' 
            };
          }
        }

        // Verifica se sono stati specificati in modo corretto gli allegati previsti.

        if (!idMess) {
          let idComponente = null
          this.item.redditi.filter(r => !!(r.percDisabilita && r.percDisabilita > 0)).forEach(r => {
            if (r.allegatoHandicap.fileName) {
              idRet = idRet && true
            } else {
              idRet = idRet && false
              idComponente = r.codiceFiscale
            }
          })
          if (!idRet) {
            idMess = `Verificare componenti nucleo familiare. Allegato richiesto non specificato (${idComponente}).`
          }
        }

        // // Verifica se intestatario indicato è lo stesso utente loggato
        // if (!idMess) {
        //   idRet = Array.isArray(this.item.redditi) ? !!this.item.redditi.find(reddito => reddito.codiceFiscale === codiceFiscale) : false
        //   if (!idRet) idMess = 'Verificare componenti nucleo familiare. Intestatario non presente.'
        // }
      }
      // console.log('titolareRequired codiceFiscale', codiceFiscale, idRet)

      return { value: idRet, descrizione: idMess }
    },

    componentiNotEmpty () {
      let idRet = true

      idRet = Array.isArray(this.item.redditi) ? (this.item.redditi.length > 0) : false
      // console.log('componentiNotEmpty ', this.item.redditi)

      return idRet
    },

    async checkImmobili (immobili) {
      // let idRet = true
      let checkValue = true
      let idMess = null

      if (immobili && Array.isArray(immobili) && immobili.length > 0) {
        // Posso fare il controllo sugli immobili

        for (let immobileToCheck in immobili) {
          if (immobili[immobileToCheck].codiceComune === 'H501') {
            let immobileChecked = await this.$store.dispatch('dichiarazioni/checkImmobile', immobili[immobileToCheck])
            // console.log('immobileChecked', immobileChecked, (immobileChecked.result_out !== 0 ? false : immobileChecked.esito_out === 'P'))
            checkValue = checkValue && (immobileChecked.result_out !== 0 ? false : immobileChecked.esito_out === 'P')
            if (!checkValue && !idMess) idMess = immobili[immobileToCheck].descrizioneComune + '(' + immobili[immobileToCheck].provincia + ') -' + immobili[immobileToCheck].indirizzo
          }
        }
      }

      // console.log('check immobili', checkValue, immobili, immobili && Array.isArray(immobili) && immobili.length > 0)

      return { value: checkValue, descrizione: idMess }
    },

    handleSubentroSelection(index) {
      // Definiamo le descrizioni delle opzioni di subentro
      const descrizioniSubentro = [
        "Assegnazione da Tribunale Civile a seguito di divorzio/separazione",
        "Unico avente diritto al subentro",
        "Primo avente diritto al subentro in base all'ordine stabilito",
        "Primo avente diritto al subentro a seguito di rinuncia"
      ];
      
      // Salviamo l'indice selezionato e la descrizione
      this.item.subentroSelezionato = {
        indice: index,
        descrizione: descrizioniSubentro[index]
      };
    }
  }
}
</script>